// for tree structure
import { FlatTreeControl } from "@angular/cdk/tree";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from 'rxjs/operators';
import { BaseService } from "../shared/services/base.service";
import { CacheService } from "../shared/services/cache.service";
import { ApproverDeligatesComponent } from "./approver-deligates/approver-deligates.component";
import { AssignApproversComponent } from './assign-approvers/assign-approvers.component';
import { AssignCustomersComponent } from './assign-customers/assign-customers.component';
import { ChildLevelsComponent } from './child-levels/child-levels.component';
import { CustomerHierarchyService } from './customer-hierarchy.service';


@Component({
    selector: 'app-customer-hierarchy',
    templateUrl: './customer-hierarchy.component.html',
    styleUrls: ['./customer-hierarchy.component.scss'],
    standalone: false
})

export class CustomerHierarchyComponent implements OnInit, OnDestroy {
  baseSiteId: string;
  nameForm: FormGroup;
  editName = false;
  submitted: boolean;
  masterSelected: boolean;
  customerCheckedList: any = [];

  // /** Flat node with expandable and level information */

  _transformer = (node, level: number) => {
    return {
      expandable: !!node.childNodes && node.childNodes.length > 0,
      name: node.name,
      level: level,
      uid: node.uid
    };
  }

  treeControl = new FlatTreeControl<any>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.childNodes
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  assignedCustmerList: any = [];
  assignedApproverList: any = [];
  b2bUnit: any;
  showChildOfNode: number;
  treeSource: Array<any> = [];
  nameBtnEnable: boolean = false;
  subs: Array<Subscription> = [];

  constructor(
    private baseSiteService: BaseSiteService,
    private readonly modalService: NgbModal,
    private readonly formBuilder: FormBuilder,
    private serviceClass: CustomerHierarchyService,
    private readonly baseService: BaseService,
    private cdr: ChangeDetectorRef,
    private user: UserAccountFacade,
    private cacheService: CacheService) {
  }

  hasChild = (_: number, node) => node.expandable;

  ngOnInit(): void {
    let userId = JSON.parse(localStorage.getItem('userId'));
    this.subs.push(
      this.baseService.get(`/users/${userId}/b2bUnits`).subscribe((res) => {
        this.b2bUnit = res?.defaultB2BUnit?.uid;
        //rendering tree in the DOM
        this.getHierarchy();
      })
    );

    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.nameForm = this.formBuilder.group({
      name: ['', Validators.required],
    });
    this.subs.push(this.nameForm.valueChanges.subscribe(value => {
      let name = JSON.parse(JSON.stringify(this.selectedNode?.name || this.treeSource[0]?.name))
      this.nameBtnEnable = (value.name === name) ? false : true;
      this.cdr.detectChanges();
    }));
    this.cacheService.cache.delete('locations');// delete the cached locations so as to fetch the newly added customer(s) when moving out of this route.
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  checkUncheckAll() {
    this.assignedCustmerList.map((item) => item.isSelected = this.masterSelected);
    this.getCheckedItemList();
  }
  isAllSelected() {
    this.masterSelected = this.assignedCustmerList.every((item: any) => item.isSelected === true);
    this.getCheckedItemList();
  }
  getCheckedItemList() {
    this.customerCheckedList = [];
    this.assignedCustmerList.forEach(element => {
      if (element.isSelected) {
        this.customerCheckedList.push(element);
      }
    });
  }
  cancelCustomer() {
    this.customerCheckedList = [];
    this.masterSelected = false;
    this.checkUncheckAll();
  }
  openChildLevelPopup(parentNode) {
    const modalref = this.modalService.open(ChildLevelsComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `child-level ${this.baseSiteId}`
    });
    modalref.componentInstance.parentNode = parentNode;
    modalref.result.catch(err => {
      if (err === 'success') {
        this.getHierarchy(this.selectedNode?.level || this.treeSource[0]?.level, this.selectedNode || this.treeSource[0])
      }
    });
  }

  openAssignCustomer(parentNode) {
    const modelref = this.modalService.open(AssignCustomersComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `assign-customer ${this.baseSiteId}`
    });
    modelref.componentInstance.parentNode = parentNode;
    modelref.result.catch(err => {
      if (err === 'success') {
        this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
      }
    });
  }

  openAssignApprover(type, parentNode, appDel?) {
    const modelref = this.modalService.open(AssignApproversComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `assign-approver ${this.baseSiteId}`
    });
    modelref.componentInstance.type = type;
    modelref.componentInstance.aprroverDetails = appDel;
    modelref.componentInstance.parentNode = parentNode;
    modelref.result.catch(err => {
      if (err === 'success') {
        this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
      }
    });
  }
  openApproverDelegate(i, appDel, parentNode) {
    const modelref = this.modalService.open(ApproverDeligatesComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `approver-delegate ${this.baseSiteId}`
    });
    modelref.componentInstance.index = i;
    modelref.componentInstance.aprroverDetails = appDel;
    modelref.componentInstance.parentNode = parentNode;
    modelref.result.catch(err => {
      if (err === 'success') {
        this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
      }
    });
  }
  get f(): any {
    return this.nameForm.controls;
  }


  removeCustomer(popover?, uid?) {
    let seletCustomer = uid ? uid.split() : this.customerCheckedList?.map((item) => item.uid);
    let params = {
      customerUnit: this.b2bUnit,
      nodeId: this.selectedNode?.uid || this.treeSource[0].uid,
      selectedCustomers: seletCustomer
    }
    this.subs.push(this.serviceClass.removeCustomer(params).subscribe((res) => {
      this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
      if (popover && popover.isOpen()) {
        popover.close();
      }
      this.customerCheckedList = [];
    }));
  }
  toggle(popoverInstance, title?: string, id?: string) {
    if (popoverInstance.isOpen()) {
      popoverInstance.close();
    } else {
      popoverInstance.open({ title, popoverInstance, id });
    }
  }



  /////////////////////////////////////////
  editNameField() {
    this.nameForm.patchValue({
      name: JSON.parse(JSON.stringify(this.selectedNode?.name || this.treeSource[0]?.name))
    });
    this.editName = !this.editName;
  }
  updateName() {
    this.subs.push(this.serviceClass.createUpdateNode('update',
      {
        nodeId: this.selectedNode?.uid || this.treeSource[0]?.uid,
        updatedName: this.f.name?.value
      }).subscribe(res => {
        if (res.status === 202) {
          // name updated
          this.editName = !this.editName;
          // call view hierarchy API to get updated tree structure
          this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
        }
      }));
  }
  getCustomerApproverList(res) {
    this.assignedApproverList = res?.customerHierarchyList[0]?.contacts;
    this.assignedCustmerList = res?.customerHierarchyList[0]?.customers;
    this.assignedCustmerList.map((item) => item.isSelected = false);
    this.masterSelected = false;
    this.customerCheckedList = [];
    this.cdr.detectChanges();
  }
  selectedNode: any;
  totalAssignableCustomers: number;
  totalAssignedCustomers: number;
  getHierarchy(level?: number, node?: any) {
    this.subs.push(this.serviceClass.getNodeHierarchy({ b2bUnit: this.b2bUnit, nodeId: node?.uid || this.b2bUnit }).subscribe(res => {
      let data = res.customerHierarchyList.map(node => ({ ...node, expandable: node.childNodes?.length > 0, level: level || 0 }));
      this.totalAssignableCustomers = res.totalAssignableCustomers;
      this.totalAssignedCustomers = res.totalAssignedCustomers;
      this.getCustomerApproverList(res);
      //invoke the recursive function and add the new child nodes to the above passed child
      this.treeSource.length > 0 ? this.findInnerNodeRecursive(this.treeSource, 'uid', node?.uid, data) : (this.dataSource.data = this.treeSource = data, this.cdr.detectChanges());
      this.treeControl.expand(this.treeControl.dataNodes[0]);
      this.cdr.detectChanges();
    }));
  }


  findInnerNodeRecursive(collection, key, value, childData) {
    for (let o of collection) {
      for (const [k, v] of Object.entries(o)) {
        if (k === key && v === value) {
          collection.splice(collection.indexOf(o), 1, childData[0]);
          this.selectedNode = childData[0];
          this.dataSource.data = this.treeSource;
          this.cdr.detectChanges();
          if (childData[0].childNodes.length > 0) {
            this.expandLeafNode(childData[0]);
          }
          else {
            this.treeControl.expand(this.getParent(this.treeControl.dataNodes[this.treeControl.dataNodes.findIndex(el => el.name === childData[0].name)]));
          }
          return;
        }
        if (Array.isArray(v)) {
          this.findInnerNodeRecursive(v, key, value, childData)
        }
      }
    }
  }

  expandLeafNode(child) {
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if (this.treeControl.dataNodes[i].name === child.name) {
        this.treeControl.expand(this.treeControl.dataNodes[i]);
      }
    }
  }

  getParent(node) {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const index = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = index; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
  }

  removeEntries(popover, id, chosenElement) {
    switch (chosenElement) {
      case 'level':
        this.subs.push(this.serviceClass.removeChild(id).subscribe(res => {
          if (res.status === 202) {
            this.toggle(popover);
            this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
          }
        }));
        break;
      case 'Approvers':
        this.subs.push(this.serviceClass.removeApprover({ sapId: id }).subscribe(res => {
          this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
        }));
        break;
      case 'Delegates':
        this.subs.push(this.serviceClass.removeDelegate({ sapId: id }).subscribe(res => {
          this.getHierarchy(this.selectedNode?.level, this.selectedNode || this.treeSource[0]);
        }));
        break;
      default:
        if (id) {
          this.removeCustomer(popover, id);
        } else {
          this.removeCustomer(popover);
        }
    }
  }


}
